export default __webpack_public_path__ + "static/media/cdpLogin.55173f55.png";